<template>
    <div class="col-md-12">
        <!-- Checkbox contratante es titular (oculto en ramo Vida) -->
        <div class="row mt-3" v-if="!esRamoVida">
            <div class="col-md-12">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="contratanteEsTitular"
                        v-model="contratanteEsTitular" @change="onContratanteEsTitularChange">
                    <label class="form-check-label" for="contratanteEsTitular">
                        ¿El contratante es el asegurado titular?
                    </label>
                </div>
            </div>
        </div>
        <!-- Botón para agregar asegurados (oculto en ramo Vida) -->
        <div class="row mt-3">
            <div class="col-md-3">
                <label class="control-label">* Asegurados</label>
            </div>
            <div class="col-md-9 text-end" v-if="!esRamoVida">
                <div>
                    <button type="button" class="btn btn-primary btn-sm" @click="addAsegurado">
                        <vue-feather type="plus" size="16"></vue-feather>
                    </button>
                </div>
            </div>
        </div>

        <div class="row mt-3">
        <!-- Tabla de asegurados -->
            <div v-for="(asegurado, index) in store.asegurados" :key="`form-${index}`">
                <div class="d-flex justify-content-between align-items-center mt-3">
                    <p>Asegurado {{ index + 1 }}</p>
                    <div>
                        <button type="button" class="btn btn-light btn-sm me-2" @click="onToggleMinimizeAsegurado(index)">
                            <vue-feather :type="asegurado.isMinimized ? 'plus' : 'minus'" size="16"></vue-feather>
                        </button>
                        <button type="button" class="btn btn-danger btn-sm" @click="onRemoveAsegurado(index)"
                            v-if="!esRamoVida">
                            <vue-feather type="trash-2" size="16"></vue-feather>
                        </button>
                    </div>
                </div>

                    <!-- Existing form content -->
                    <div v-if="!asegurado.isMinimized">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label class="control-label">* Parentesco</label>
                                    <select class="form-control" required="required" v-model="asegurado.parentesco">
                                        <option value="" disabled selected>Seleccione una opción</option>
                                        <option>Titular</option>
                                        <option>Hijo</option>
                                        <option>Conyuge</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label class="control-label">* Género</label>
                                    <select class="form-control" required="required" v-model="asegurado.genero" :disabled="!asegurado.parentesco">
                                        <option value="" disabled selected>Seleccione una opción</option>
                                        <option>Masculino</option>
                                        <option>Femenino</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label class="control-label">* Fecha de Nacimiento</label>
                                    <input v-model="asegurado.fechaNacimiento" @change="calculateAge(asegurado)" class="form-control" type="date" required="required" :disabled="!asegurado.genero">
                                </div>
                            </div>
                            <div class="col-md-1">
                                <div class="form-group">
                                    <label class="control-label">* Edad</label>
                                    <input class="form-control" type="text" placeholder=""
                                        v-bind:class="formSubmitted ? firstError ? 'is-invalid' : 'is-valid' : ''" required="required"
                                        v-model="asegurado.edad" readonly>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label class="control-label">* País</label>
                                    <select class="form-control" required="required"
                                        v-model="asegurado.paisId"
                                        :disabled="!asegurado.fechaNacimiento"
                                        @change="getEstado(asegurado.paisId, asegurado)">
                                        <option value="" disabled selected>Seleccione una opción</option>
                                        <option v-for="pais in paises" :key="pais.id" :value="pais.id">
                                            {{ pais.nombre }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label class="control-label">* Estado</label>
                                    <select class="form-control" required="required"
                                        v-model="asegurado.estadoId"
                                        :disabled="!asegurado.paisId || !asegurado.estadosNacimiento.length">
                                        <option value="" disabled selected>Seleccione una opción</option>
                                        <option v-for="estado in asegurado.estadosNacimiento" :key="estado.id" :value="estado.id">
                                            {{ estado.nombre }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="control-label">* Nombre(s)</label>
                                <input v-model="asegurado.nombre" class="form-control" type="text" placeholder="" required="required" :disabled="!asegurado.estadoId">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="control-label">* Apellido Paterno</label>
                                <input v-model="asegurado.paterno" class="form-control" type="text" placeholder="" required="required" :disabled="!asegurado.nombre">
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="control-label">Apellido Materno</label>
                                <input v-model="asegurado.materno" class="form-control" type="text" placeholder="" :disabled="!asegurado.paterno">
                            </div>
                        </div>
                    </div>

                    <div class="row mt-3">
                        <div class="col-md-3" v-if="!esRamoVida">
                            <div class="form-group">
                                <label class="control-label">* Antigüedad</label>
                                <input v-model="asegurado.antiguedad" class="form-control" type="date" required="required" :disabled="!asegurado.paterno">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="control-label">* Fecha de alta</label>
                                <input v-model="asegurado.fechaAlta" @change="calculateDiasContratados(asegurado)" class="form-control" type="date" required="required" :disabled="!esRamoVida && !asegurado.antiguedad">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="control-label">* Fecha de fin</label>
                                <input v-model="asegurado.fechaFin" @change="calculateDiasContratados(asegurado)" class="form-control" type="date" required="required" :disabled="!asegurado.fechaAlta">
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="control-label">Días contratados</label>
                                <input v-model="asegurado.diasContratados" class="form-control" type="text" placeholder="" readonly>
                            </div>
                        </div>
                    </div>
            </div>
        </div>

        <hr class="mt-3" />
        <div class="mt-3 col-md-12">
            <p><b>* Campos obligatorios</b></p>
        </div>

        <div class="mt-3 col-md-12">
            <button type="button" class="btn btn-primary float-end" :disabled="loading" @click.prevent="onRegistraAseguradosYAvanza">
                Guardar y avanzar
            </button>
        </div>
    </div>
</template>

<script>
import api from '@/axios';
import { fetchAllItems } from '@/utils/listResponse';
import { useSeguroStore } from '@/stores/seguroStore';
import getField from '@/utils/getField';
import { familiaPorRamoId, FAMILIA_VIDA } from '@/utils/familiaSeguro';


export default {
    setup() {
        const store = useSeguroStore();
        return { store };
    },
    data() {
        return {
            loading: false,
            contratanteEsTitular: false,
            paises: [],
        };
    },
    computed: {
        // Vida Familiar: el único asegurado es el contratante (según la familia del ramo, no su nombre).
        esRamoVida() {
            return familiaPorRamoId(this.store.ramoId) === FAMILIA_VIDA;
        },
    },
    watch: {
        esRamoVida: {
            immediate: true,
            handler(isVida) {
                if (isVida) {
                    this.contratanteEsTitular = true;
                    this.onContratanteEsTitularChange();
                }
            },
        },
    },
    mounted() {
        this.getPaises();
    },
    methods: {
        async getPaises() {
            try {
                this.paises = (await fetchAllItems('paises')).items;
            } catch (err) {
                this.paises = [];
            }
        },
        async getEstado(paisId, asegurado) {
            if (!paisId || !asegurado) {
                return;
            }

            asegurado.paisNombre = this.paises.find(p => p.id == paisId)?.nombre || '';
            asegurado.estadoId = '';
            asegurado.estadosNacimiento = [];

            try {
                asegurado.estadosNacimiento = (await fetchAllItems(`estados/pais/${paisId}`)).items;
            } catch (err) {
                asegurado.estadosNacimiento = [];
            }
        },
        async registraAsegurados() {
            if (!this.store.polizaId) {
                return false;
            }
            try {
                this.loading = true;
                const payload = this.store.buildWizardDto(4);
                const response = await api.put(`wizard/poliza/${this.store.polizaId}`, payload);
                if (response.status >= 200 && response.status < 300) {
                    const data = response.data || {};
                    this.store.polizaVersionId = getField(data, 'polizaVersionId') ?? this.store.polizaVersionId;
                    this.store.etapaWizard = 4;
                    return true;
                }
                return false;
            } catch (err) {
                return false;
            } finally {
                this.loading = false;
            }
        },
        async onRegistraAseguradosYAvanza() {
            const ok = await this.registraAsegurados();
            if (ok) {
                this.$emit('nextTab');
            }
        },
        onContratanteEsTitularChange() {
            if (this.contratanteEsTitular) {
                const titularIndex = this.store.asegurados.findIndex(a => a.esTitularContratante);
                const titular = {
                    rfc: this.store.rfc || '',
                    curp: this.store.curp || '',
                    nombre: this.store.nombre || '',
                    paterno: this.store.paterno || '',
                    materno: this.store.materno || '',
                    fechaNacimiento: this.store.fechaNacimiento || '',
                    edad: this.store.edad || '',
                    paisId: '',
                    paisNombre: '',
                    estadoId: '',
                    estadosNacimiento: [],
                    genero: '',
                    parentesco: 'Titular',
                    antiguedad: '',
                    fechaAlta: '',
                    fechaFin: '',
                    diasContratados: '',
                    prima: 0,
                    isMinimized: false,
                    esTitularContratante: true,
                };
                if (titularIndex >= 0) {
                    this.store.asegurados.splice(titularIndex, 1, titular);
                } else {
                    if (!Array.isArray(this.store.asegurados)) this.store.asegurados = [];
                    this.store.asegurados.unshift(titular);
                }
            } else {
                const titularIndex = this.store.asegurados.findIndex(a => a.esTitularContratante);
                if (titularIndex >= 0) {
                    this.store.asegurados.splice(titularIndex, 1);
                }
            }
        },
        calculateAge(asegurado) {
            if (!asegurado.fechaNacimiento) {
                asegurado.edad = '';
                return;
            }
            const birthDate = new Date(asegurado.fechaNacimiento);
            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            const m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            asegurado.edad = age;
        },
        addAsegurado() {
            if (!Array.isArray(this.store.asegurados)) {
                this.store.asegurados = [];
            }
            this.store.asegurados.push({
                rfc: '',
                curp: '',
                nombre: '',
                paterno: '',
                materno: '',
                fechaNacimiento: '',
                edad: '',
                paisId: '',
                paisNombre: '',
                estadoId: '',
                estadosNacimiento: [],
                genero: '',
                parentesco: '',
                antiguedad: '',
                fechaAlta: '',
                fechaFin: '',
                diasContratados: '',
                prima: 0,
                isMinimized: false,
            });
        },
        onToggleMinimizeAsegurado(index) {
            const asegurado = this.store.asegurados[index];
            asegurado.isMinimized = !asegurado.isMinimized;
        },
        onRemoveAsegurado(index) {
            this.store.asegurados.splice(index, 1);
        },
        calculateDiasContratados(asegurado) {
            if (!asegurado.fechaAlta || !asegurado.fechaFin) {
                asegurado.diasContratados = '';
                return;
            }
            const dias = Math.round((new Date(asegurado.fechaFin) - new Date(asegurado.fechaAlta)) / (1000 * 60 * 60 * 24));
            asegurado.diasContratados = dias >= 0 ? dias : 'Rango de fechas inválido';
        },
        async onSearchRFC(asegurado) {
            if (!asegurado.rfc) return;
            try {
                this.loading = true;
                const response = await api.get(`informacionpersonal/rfc/${asegurado.rfc}`);
                if (response.status === 200) {
                    asegurado.curp = response.data.curp;
                    asegurado.fechaNacimiento = new Date(response.data.fechaNacimiento).toISOString().split('T')[0];
                    this.calculateAge(asegurado);
                    asegurado.nombre = response.data.nombre;
                    asegurado.paterno = response.data.paterno;
                    asegurado.materno = response.data.materno;
                }
            } catch (err) {
                asegurado.curp = '';
                asegurado.fechaNacimiento = '';
                asegurado.edad = '';
                asegurado.nombre = '';
                asegurado.paterno = '';
                asegurado.materno = '';
            } finally {
                this.loading = false;
            }
        },
    }
}
</script>
